import React from 'react';
import { SubDepartmentControl } from 'src/components/common/SubDepartmentControl/SubDepartmentControl';
import { useSubDepartmentControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/SubDepartmentControlWrapper/hooks/useSubDepartmentControlWrapper';

export function SubDepartmentControlWrapper(): JSX.Element | null {
  const { isVisible } = useSubDepartmentControlWrapper();

  if (!isVisible) {
    return null;
  }

  return <SubDepartmentControl name="subDepartment" id="subDepartment" />;
}
